import React from 'react';

const VersionPageConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/versions',
			exact: true,
			component: React.lazy(() => import('./VersionPage'))
		}
	]
};

export default VersionPageConfig;
